var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { SwipeableDrawer as MuiSwipeableDrawer, } from '@material-ui/core';
import { makeStyles } from "../../styles/index";
var useStyles = makeStyles(function () { return ({
    drawer: {
        pointerEvents: 'none',
        '& .MuiPaper-root': {
            overflow: 'visible',
        },
        '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
        },
    },
    edge: {
        position: 'absolute',
        top: function (_a) {
            var edgeWidth = _a.edgeWidth;
            return -edgeWidth;
        },
        left: 0,
        right: 0,
        height: function (_a) {
            var edgeWidth = _a.edgeWidth;
            return edgeWidth;
        },
        visibility: 'visible',
        pointerEvents: 'all',
    },
    children: {
        pointerEvents: 'all',
    },
}); });
/**
 * エッジ付きのドロワー
 */
export var EdgeDrawer = function (props) {
    var nothingToDo = function () {
        // nothing to do
    };
    var open = props.open, edgeWidth = props.edgeWidth, edgeElement = props.edgeElement, anchor = props.anchor, children = props.children, className = props.className, style = props.style, classes = props.classes, _a = props.onOpen, onOpen = _a === void 0 ? nothingToDo : _a, _b = props.onClose, onClose = _b === void 0 ? nothingToDo : _b, others = __rest(props, ["open", "edgeWidth", "edgeElement", "anchor", "children", "className", "style", "classes", "onOpen", "onClose"]);
    var drawerClasses = useStyles(props);
    return (React.createElement(MuiSwipeableDrawer, __assign({ open: open, className: classNames(drawerClasses.drawer, className), PaperProps: { style: style }, anchor: anchor, classes: classes, disableSwipeToOpen: true, onOpen: onOpen, onClose: onClose, swipeAreaWidth: edgeWidth, ModalProps: {
            keepMounted: true,
        } }, others),
        React.createElement("div", { className: drawerClasses.edge }, edgeElement),
        React.createElement("div", { className: drawerClasses.children }, children)));
};
